/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import './styles.scss'

export class Storage extends React.Component<Props, State> {
  render () {
    return (
      <div className='storage'>
        <div className='icon-wrapper'>
          <img src={this.props.icon} />
        </div>
        <div className='info'>
          <div
            className='info-header'
            style={{
              color: this.props.fontcolor,
              borderBottom: '1px solid ' + this.props.fontcolor
            }}
          >
            <div className='title'>{this.props.title}</div>
            <div className='year'>{this.props.year}</div>
          </div>
          <div className='info-wrapper'>
            <div className='capacity'>{this.props.capacity}</div>
            <div className='wrapper'>
              <div className='comparison'>
                <div className='multiplier'>{this.props.multiplier1 ? this.props.multiplier1 : ''}{this.props.multiplier1 && (
                  <span className='times'>×</span>
                )}
                </div>
                <div className='icon'>
                  <img src={this.props.comparison1} />
                </div>
              </div>
              {this.props.multiplier2 && (
                <div className='comparison'>
                  <div className='multiplier'>{this.props.multiplier2 ? this.props.multiplier2 : ''}
                    <span className='times'>×</span>
                  </div>
                  <div className='icon'>
                    <img src={this.props.comparison2} />
                  </div>
                </div>
              )}
            </div>
            <div className='wrapper'>
              <div className='comparison'>
                <div className='multiplier'>{this.props.multiplier3 ? this.props.multiplier3 : ''}{this.props.multiplier3 && (
                  <span className='times'>×</span>
                )}
                </div>
                <div className='icon'>
                  <img src={this.props.comparison3} />
                </div>
              </div>
              {this.props.multiplier4 && (
                <div className='comparison' style={{ float: 'none' }}>
                  <div className='multiplier'>{this.props.multiplier4 ? this.props.multiplier4 : ''}
                    <span className='times'>×</span>
                  </div>
                  <div className='icon'>
                    <img src={this.props.comparison4} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div >
    )
  }
}
